<template>
    <div class="travelDetail-introNav introNavActive">
        <div v-swiper:mySwiper="swiperOptions" class="swiper-container swiper-container1">
            <div class="swiper-wrapper">
                <!--先分组 三个一组 循环取值-->
                <div class="swiper-slide" v-for="(item, index) in dataList" :key="index">
                    <div class="introNav-item" v-for="subItem in item" :key="subItem.day">
                        <div class="introNav-itemTxt">{{subItem.dayTitle}}</div>
                        <div class="introNav-itemDot"><span></span></div>
                        <div class="introNav-itemTxt">{{subItem.title}}</div>
                        <a class="hold-link external" @click="slideTo(subItem.day)"></a>
                    </div>
                </div>
            </div>
        </div>
        <!-- 分页 -->
        <div class="swiper-pagination" style="display: none;"></div>
        <!-- 左右按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
    </div>
</template>

<script>
    import { directive } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    export default {
        name: 'TravelNoteDetailSlideTop',
        directives: {
            swiper: directive
        },
        props: {
            dataList: {
                type: Array,
                default: function () {}
            },
            activeDay: {
                type: Number,
                default: 0
            }
        },
        data () {
            return {
                swiperOptions: {
                    loop: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                        disabledClass: 'swiper-button-disabled'
                    }
                },
                activeIndex: 0
            }
        },
        watch: {
            'activeDay' (newVal) {
                let active = Math.floor((newVal - 1) / 3)
                if (this.mySwiper.activeIndex !== active) {
                    if (active > this.activeIndex) this.mySwiper.slideNext()
                    if (active < this.activeIndex) this.mySwiper.slidePrev()
                }
                this.activeIndex = active
            }
        },
        methods: {
            slideTo (day) {
                this.$emit('on-slide-to', day)
            }
        }
    }
</script>

<style lang="less" scoped>
    .hold-link {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .travelDetail-introNav {
        margin-top: 2px;
        height: 88px;
        padding:0 26px 0 26px;
        background-color: #061556;
        position:relative;
    }
    .travelDetail-introNav.fixedActive {
        position:fixed;
        top:48px;
        left:0;
        width:100%;
        height:48px;
        z-index:666;
    }
    .travelDetail-introNav .introNav-item {
        float:left;
        padding-top:13px;
        width:33.33%;
        height:88px;
        position:relative;
    }
    .travelDetail-introNav .introNav-itemTxt {
        color: #fff;
        font-size: 12px;
        text-align: center;
        transform: scale(.9);
        -webkit-transform: scale(.9);
        -moz-transform: scale(.9);
        -o-transform: scale(.9);
    }
    .travelDetail-introNav .introNav-itemDot {
        height:12px;
    }
    .travelDetail-introNav .introNav-itemDot>span {
        width:12px;
        height:12px;
        background-color: #fff;
        border: 1px solid #e3e3e3;
        border-radius:6px;
        margin:0 auto;
        display:inline-block;
        position:relative;
        vertical-align:top;
    }
    .travelDetail-introNav .introNav-itemDot > span::before {
        position: absolute;
        left: 11px;
        top: 4px;
        content: '';
        border: 1px solid #e3e3e3;
        width: 46px;
    }
    .travelDetail-introNav .introNav-itemDot > span::after {
        position: absolute;
        right: 11px;
        top: 4px;
        content: '';
        border: 1px solid #e3e3e3;
        width: 46px;
    }
    .travelDetail-introNav .introNav-item:first-child .introNav-itemDot > span::after,
    .travelDetail-introNav .introNav-item:last-child .introNav-itemDot > span::before{
        display: none;
    }
    .travelDetail-introNav .introNav-item.active .introNav-itemTxt {
        color: #f6b511;
    }
    .travelDetail-introNav .introNav-item.active .introNav-itemDot>span{
        background-color: #f6b511;
        border: 1px solid #7e6533;
    }
    .travelDetail-introNav .swiper-container {
        padding: 0;
    }
    .travelDetail-introNav .swiper-container .swiper-slide {
        text-align:center;
    }
    .travelDetail-introNav .swiper-button-prev {
        background-image: url(../../assets/carouselLeftArrow.png);
        transform: scale(.5);
        -webkit-transform: scale(.5);
        -moz-transform: scale(.5);
        -o-transform: scale(.5);
        left: 0;
        top:43%;
        &::after{
            display: none;
        }
    }
    .travelDetail-introNav .swiper-button-next {
        background-image: url(../../assets/carouselRightArrow.png);
        transform: scale(.5);
        -webkit-transform: scale(.5);
        -moz-transform: scale(.5);
        -o-transform: scale(.5);
        right: 0;
        top:43%;
        &::after{
            display: none;
        }
    }
</style>
